import {LoginType} from '../../shared/models/api';
import {formatPhone, formatSnils, formatUsc, onlyDigitsPipe} from '../../shared/pipes';

export const formatLoginLabel = (loginType?: LoginType): string => {
  switch (loginType) {
    case 'EskNumber':
      return 'Номер карты';
    case 'PhoneNumber':
      return 'Телефон';
    case 'Snils':
      return 'СНИЛС';
    default:
      return 'Номер карты, телефон, СНИЛС';
  }
};
export const formatIdentificator = (value: string, loginType?: LoginType) => {
  if (loginType === LoginType.PhoneNumber && value) {
    let phone = value;

    if (phone[0] === '9') {
      phone = '8' + phone;
    }
    if (phone[0] === '7') {
      phone = phone.replace(/^7/, '8');
    }
    return formatPhone(phone);
  }
  if (loginType === LoginType.EskNumber && typeof value === 'string') {
    return formatUsc(value);
  }
  if (loginType === LoginType.Snils && typeof value === 'string') {
    return formatSnils(value);
  }
  if (typeof loginType === 'undefined' && value) {
    return onlyDigitsPipe(value);
  }
  return value;
};
